export const ChangeTitle = (title) =>{
    return (document.title = "Fitness Cloud - "+ title);
};